export default {
    name: 'HeaderDivider'
};
